import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export function RowSpacing(props) {
  return (
    <FormControl variant="standard" sx={{ minWidth: 166 }}>
      <InputLabel id="rowspacing">Row Spacing</InputLabel>
      <Select data-testid="row-spacing" id="rowspacing" {...props}>
        <MenuItem value=""></MenuItem>
        <MenuItem value="7.5">7.5</MenuItem>
        <MenuItem value="15">15</MenuItem>
        <MenuItem value="20">20</MenuItem>
        <MenuItem value="30">30</MenuItem>
        <MenuItem value="36">36</MenuItem>
      </Select>
    </FormControl>
  );
}
